function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { uniqBy } from '@docavenue/core';
var STETHOSCOPE = 'device_stethoscope';
var OTOSCOPE = 'device_otoscope';
var stethoscopes = ['PCP-USB'];
var otoscopes = ['Otoscope', 'Microscope'];
/**
 * This function takes a technical name of a device and return a human-friendly name for it.
 */

var transform = function transform(label) {
  var filters = [function checkStethoscope(name) {
    return stethoscopes.reduce(function (value, type) {
      return value || name.indexOf(type) >= 0;
    }, false) ? STETHOSCOPE : name;
  }, function checkOtoscope(name) {
    return otoscopes.reduce(function (value, type) {
      return value || name.indexOf(type) >= 0;
    }, false) ? OTOSCOPE : name;
  }, // Remove technical term from device label. For example, most of devices have this form 'Device label (xxxx:xxxx)'
  function cleanUp(name) {
    var matches = /(.+?) \(([^)]+)\)/g.exec(name);

    if (matches && matches.length > 1) {
      return matches[1];
    }

    return name;
  }];
  return filters.reduce(function (v, f) {
    return f(v);
  }, label);
};
/**
 * Clean device names then remove duplication
 * @param devices
 * @returns array<Device>
 */


var cleanDeviceNames = function cleanDeviceNames(t) {
  return function (devices) {
    return (// @ts-ignore
      uniqBy(devices.map(function (device) {
        return _objectSpread(_objectSpread({}, device), {}, {
          label: t(transform(device.label)),
          key: transform(device.key)
        });
      }), 'label')
    );
  };
};

var mapDeviceFn = function mapDeviceFn(device) {
  return {
    id: device.deviceId,
    label: device.label,
    key: device.label
  };
};

export var askPermission = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var ret, devices, hasAudioInput, hasVideoInput;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ret = {
              camera: 'unsupported',
              microphone: 'unsupported'
            };
            _context.next = 3;
            return navigator.mediaDevices.enumerateDevices();

          case 3:
            devices = _context.sent;
            hasAudioInput = devices.some(function (d) {
              return d.kind === 'audioinput';
            });
            hasVideoInput = devices.some(function (d) {
              return d.kind === 'videoinput';
            });

            if (!(hasAudioInput && hasVideoInput)) {
              _context.next = 20;
              break;
            }

            _context.prev = 7;
            _context.next = 10;
            return navigator.mediaDevices.getUserMedia({
              video: true,
              audio: true
            }).then(function (stream) {
              return stream.getTracks().forEach(function (track) {
                return track.stop();
              });
            });

          case 10:
            ret.microphone = 'granted';
            ret.camera = 'granted';
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
            ret.camera = 'dennied';
            ret.microphone = 'dennied';

          case 18:
            _context.next = 42;
            break;

          case 20:
            if (!hasAudioInput) {
              _context.next = 32;
              break;
            }

            _context.prev = 21;
            _context.next = 24;
            return navigator.mediaDevices.getUserMedia({
              audio: true
            }).then(function (stream) {
              return stream.getTracks().forEach(function (track) {
                return track.stop();
              });
            });

          case 24:
            ret.microphone = 'granted';
            _context.next = 30;
            break;

          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](21);
            ret.microphone = 'dennied';

          case 30:
            _context.next = 42;
            break;

          case 32:
            if (!hasVideoInput) {
              _context.next = 42;
              break;
            }

            _context.prev = 33;
            _context.next = 36;
            return navigator.mediaDevices.getUserMedia({
              video: true
            }).then(function (stream) {
              return stream.getTracks().forEach(function (track) {
                return track.stop();
              });
            });

          case 36:
            ret.camera = 'granted';
            _context.next = 42;
            break;

          case 39:
            _context.prev = 39;
            _context.t2 = _context["catch"](33);
            ret.camera = 'dennied';

          case 42:
            return _context.abrupt("return", ret);

          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 14], [21, 27], [33, 39]]);
  }));

  return function askPermission() {
    return _ref.apply(this, arguments);
  };
}();
export var getListMediaDevices = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(t) {
    var opts,
        devices,
        inputDevices,
        audioDevices,
        videoDevices,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.next = 3;
            return navigator.mediaDevices.enumerateDevices();

          case 3:
            devices = _context2.sent;

            if (!(opts !== null && opts !== void 0 && opts.askPermission)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return askPermission();

          case 7:
            _context2.next = 9;
            return navigator.mediaDevices.enumerateDevices();

          case 9:
            devices = _context2.sent;

          case 10:
            inputDevices = devices.filter(function (device) {
              return ['audioinput', 'videoinput'].includes(device.kind);
            });
            audioDevices = inputDevices.filter(function (device) {
              return device.kind === 'audioinput';
            }).map(mapDeviceFn);
            videoDevices = inputDevices.filter(function (device) {
              return device.kind === 'videoinput';
            }).map(mapDeviceFn);
            return _context2.abrupt("return", {
              audioDevices: cleanDeviceNames(t)(audioDevices),
              videoDevices: cleanDeviceNames(t)(videoDevices)
            });

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getListMediaDevices(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // The ultility for check permission of camera and microphone
// The reason exist this function because firefox not supported Permissions_API
// https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API

export var permissionQuery = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
    var _navigator;

    var fallback,
        queryByName,
        permision,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fallback = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
            queryByName = {
              camera: {
                video: true
              },
              microphone: {
                audio: true
              }
            };

            if (!((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.permissions)) {
              _context3.next = 15;
              break;
            }

            _context3.prev = 3;
            _context3.next = 6;
            return navigator.permissions.query({
              name: name
            });

          case 6:
            permision = _context3.sent;
            return _context3.abrupt("return", permision.state);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](3);

            if (fallback) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", 'unsupported');

          case 14:
            // eslint-disable-next-line no-console
            console.log('navigator.permissions.query not support, try fallback');

          case 15:
            return _context3.abrupt("return", navigator.mediaDevices.getUserMedia(queryByName[name]).then(function (stream) {
              stream.getTracks().forEach(function (track) {
                return track.stop();
              });
              return 'granted';
            }).catch(function () {
              return (// This case may contain no camera or no microphone
                'denied'
              );
            }));

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 10]]);
  }));

  return function permissionQuery(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
//# sourceMappingURL=utils.js.map